export default __webpack_public_path__ + "assets/models/121482d901423252a4a83adbffae3eff.glb";